import type { CodeSetItemKind } from './types';

/** Row subtitle for each saved-volume kind. */
export const CODE_SET_KIND_SUBTITLES: Record<CodeSetItemKind, string> = {
  cohort: 'Encounters',
  filterSet: 'All Claims',
  advancedSearch: 'AI Search',
};
